import { useMutation, useQueryClient } from 'react-query'
import { config } from 'config'
import { callAxios, CustomAxiosError } from 'utils/api'
import { MessageRequest, MessageStatusResponse } from 'pages/admin/supplierMessaging/types'

const { SECURE_BASE_URL } = config!

const addMessage = async (props: MessageRequest): Promise<MessageStatusResponse> => {
  const { message, startDate, startTime, endDate, endTime, remarks } = props

  const { response: addMessageResponse } = await callAxios<{
    response: MessageStatusResponse
  }>({
    url: `${SECURE_BASE_URL}/createMessage`,
    method: 'POST',
    data: {
      message,
      startDate,
      startTime,
      endDate,
      endTime,
      remarks,
      operation: 'create',
    },
  })

  return addMessageResponse
}

export const useAddMessage = () => {
  const queryClient = useQueryClient()

  const {
    status: getAddMessageStatus,
    data: addMessageData,
    error: getAddMessageError,
    mutate: mutateAddMessage,
  } = useMutation<MessageStatusResponse, CustomAxiosError, MessageRequest>(addMessage, {
    onSuccess: () => {
      queryClient.invalidateQueries('supplierMessages/get')
    },
  })

  return {
    getAddMessageStatus,
    addMessageData,
    getAddMessageError,
    mutateAddMessage,
  }
}
